const translateAssine = {
  portugues: {
    anual: '/ anual',
    apartir: 'A partir de',
    title: 'Assine Agora!',
    bePart: 'Faça parte do Clube Bella',
    subTitle: 'E tenha um clube de vantagens!',
    subTitleFreetour: 'É fácil, rápido e seguro.',
    legendFreetour: 'Escolha o melhor plano para você e assine agora mesmo!',
    header: 'Ainda não é sócio?',
    codeEmail: 'Enviamos para o seu email um código de confirmação. Por favor, digite o código abaixo:',
    codeEmailSpam: 'Não recebeu o código? Verifique sua caixa de spam ou lixo eletrônico.',   
    subBenefits:
      'Aproveite para desfrutar do melhor Clube de internet e tenha um mundo de vantagens.',
    listBenefits: [
      'HD photos',
      'Vídeos em 4K* (Ultra HD)',
      'Assista transmissões ao vivo dos ensaios sem censura',
      'Acesso a todos os Making Of gravados em 4K *(ULTRA HD) ',
      'Seção exclusiva só com pezinhos',
      'Ensaios Completos com fotos exclusivas',
      'Mais de 40.000 fotos e centenas de vídeos',
      'Bella Cloud: sua pasta na nuvem para guardar suas fotos e vídeos favoritos',
      'ASSINATURA SIGILOSA (o nome do Bella não aparece na fatura do seu cartão de crédito, nem em sua conta bancária).'
    ],
    listBenefitsMobile: [
      'HD photos',
      'Vídeos em 4K* (Ultra HD)',
      'Transmissões ao vivo dos ensaios sem censura',
      'Acesso aos Making Of gravados em 4K *(ULTRA HD) ',
      'Seção exclusiva só com pezinhos',
      /*'Ensaios Completos com fotos exclusivas',*/
      'Mais de 40.000 fotos e centenas de vídeos',
      'Bella Cloud: sua pasta na nuvem para fotos e vídeos'
      /*'ASSINATURA SIGILOSA(o nome do Bella não aparece na fatura do seu cartão de crédito, nem em sua conta bancária).'*/
    ],
    footerBenefits: '* Todas cobranças aparecem como BDS',
    footerDownloadLimit1: '** Limite de',
    footerDownloadLimit2: 'downloads por dia',
    buttonSubscribe: 'Assine agora',
    buttonCredits: 'Compre Créditos',
    buttonCredits2: 'Compre Agora',
    buttonCreditsAssinante: 'SIM, QUERO CRÉDITOS EM DOBRO!',
    buttonSubscribe2: 'Assine',
    buttonSubscribe3: 'Faça parte',
    buttonSubscribe4: 'Fazer upgrade',
    buttonSubscribe5: 'Renovar',
    holderSocio: 'Já é sócio?',
    holderLogin: 'Faça seu login',
    titleFormUser: 'Informe seus dados:',
    formUser: {
      firstName: 'Nome',
      lastName: 'Sobrenome',
      email: 'E-mail',
      emailAgain: 'Confirme seu e-mail',
      anotherEmail: 'E-mail alternativo (opcional)',
      country: 'País',
      password: 'Senha',
      passwordAgain: 'Redigite sua senha',
      token: 'Codigo de confirmação de email'
    },
    legendaAssinePagamentosTitle:
      '*Válido apenas para cartão de crédito. Para obter o parcelamento é necessário que você selecione quantas parcelas deseja (1x, 2x ou 3x), logo abaixo do pedido do código de segurança do cartão',
    legendaAssinePagamentosSubTitle:
      'Para sua conveniência, sua assinatura será automaticamente renovada por períodos equivalentes. Para cancelar, solicite pelo menu Contato.',
    PlansSubTitle: 'Escolha a sua forma de pagamento:',
    AlterPlansSubTitle: 'Escolha a sua forma de pagamento:',
    AlterPaymentSubTitle: 'Forma de pagamento',
    nameHolderCreditCards: 'Nome do portador',
    cpfCreditCards: 'CPF do portador',
    numberCreditCards: 'Número do cartão',
    validCreditCards: 'Validade mês/ano',
    parcelas: 'Número de Parcelas',
    cvvCreditCards: 'Código de segurança',
    cartaoInvalido: {
      number: 'Número do cartão inválido. Confira os dígitos.',
      expiration: 'Validade do cartão inválida ou vencida.',
      verification_value: 'Código de segurança inválido.',
    },
    PlanValueDay: 'apenas',
    Promotionexclusive: 'PROMOÇÃO EXCLUSIVA',
    day: 'dia',
    current: 'R$',
    legendFormCreditCard:
      'Pague com cartão de crédito, é rápido e totalmente seguro.<br> Seu acesso é liberado imediatamente após o pagamento. <br>Para maior discrição, o débito aparecerá na fatura do seu cartão de crédito como BDS.',
    legendFormTransfer:
      'Se você tem conta no Itaú pague através do ITAU Shopline, é simples e totalmente seguro.<br>Pagando com Transferência Eletrônica o correntista<br>Itaú tem seu acesso é liberado em poucos minutos após o pagamento.<br>Ao clicar em "CONCLUIR COMPRA", desbloqueie os POP-UPS do navegador para abrir a página do Itaú Shopline.',
    legendFormPix:
      'Clique em Gerar QRCode e aponte a câmera do seu celular com seu aplicativo bancário para pagar via Pix ou copie o código gerado abaixo da imagem e cole no seu aplicativo bancário do Pix para efetuar o pagamento.<br><br><strong>ATENÇÃO: o código e QRCode são válidos apenas por 1 hora.</strong>',
    noticePixRecurrence:
      'Pix com renovação automática<br> <strong>Cancele a qualquer momento</strong> pelo app do seu banco ou diretamente na sua conta no Bella.',
    legendFormBoleto:
      'Escolhendo esta opção, será aberta em nova janela o boleto bancário.<br>Imprima e pague o boleto em qualquer agência bancária até a data do vencimento.<br>Será cobrado o valor do plano de assinatura escolhido acrescido<br>do custo do boleto, no valor de R$ 3,00.<br><br>Seu acesso somente será liberado após a compensação do pagamento,que ocorrem em até<br><strong>3 dias úteis após o pagamento.</strong>',
    titleTermsUse: 'Termos e Condições',
    aceitlabel: 'Li e aceito os termos e condições.',
    buttonLabelFinish: 'Finalizar assinatura',
    legendaMyAcoountPagamentosSubTitle1: `*Válido apenas para cartão de crédito. Para obter o parcelamento é necessário que você selecione quantas parcelas deseja (1x, 2x ou 3x), logo abaixo do pedido do código de segurança do cartão.`,
    legendaMyAcoountPagamentosSubTitle2: `Para sua conveniência, sua assinatura será automaticamente renovada por períodos equivalentes. Para cancelar, solicite pelo menu Contato.`,
    AlterPlansDescription1: 'Seu plano atual de assinatura atual é:',
    AlterPlansDescription2:
      'Se você deseja alterar o plano basta selecionar uma das opções abaixo.',
    AlterPaymentDescription1: 'Seu formato de pagamento atual é:',
    AlterPaymentDescription2:
      'Se você deseja alterar o seu formato de pagamento, basta selecionar uma das opções abaixo.',
    PromotionSpecial: 'PROMOÇÃO',
    labelDiscont: 'OFF',
    credits: {
      subBenefits:
        'Garanta logo abaixo seus créditos para download e compre os vídeos exclusivamente para você.',
      listBenefits: [
        'Assinantes do Bella ganham o <strong>DOBRO de Créditos;</strong>',
        /*'Não há necessidade de assinatura ativa, proporcionando liberdade total de escolha;',*/
        'Desfrute de conteúdo exclusivo e assista às suas modelos favoritas em 4K;',
        'Salve os vídeos para assistir em qualquer lugar, sem a necessidade de conexão à internet.',
        /*'Praticidade: assista em qualquer lugar, sem a necessidade de conexão à internet.'*/
      ],
      title: 'Compre Créditos para Download',
      subTitle: 'E adquira vídeos exclusivos em 4K das suas modelos favoritas',
      title2: 'Dê um Turbo na sua assinatura!',
      subTitle2:
        'Acrescente mais créditos de download de vídeos e making of à sua conta com um desconto especial.',
        buy: 'Compre',
        gain: 'e leve',
        credits: 'créditos',
      footerBenefits: '* Cada download de 1 vídeo da modelo corresponde a 1 crédito',
      footerBenefits2: '* Cada download de 1 vídeo de making of corresponde a 2 créditos',
      PlansSubTitle: 'Conheça os pacotes de downloads:',
      PlansAssi: 'Assinante',
      PlansNoAssi: 'Não Assinante',
      PlansTitle: 'Escolha a quantidade de créditos:',
      recive: 'recebe',
      price: 'Valor',
      option: 'Selecione a opção desejada:',
      subscribeInfo:
        'Para completar a compra como assinante é preciso ter uma conta ativa de assinante do Bella da Semana. Você será direcionado para a página de login antes do pagamento.'
    },
    PlanPrevTitle: 'Conheça nossos planos:',
    double: 'RECEBA EM DOBRO',
    assineOptions1: 'Plano de Assinatura',
    assineOptions2: 'Créditos para Downloads',
    perMonth: '/ mês',
    totalValue: 'à vista',
    textCredits1: 'GANHE',
    textCredits2: 'até',
    textCredits3: 'Créditos de DOWNLOADS',
    textCredits4: 'ILIMITADOS',
    // Mensagem de créditos do Gold em 2 linhas (GANHE em destaque).
    textCreditsWord: 'créditos',
    textCreditsUnlimited: 'de DOWNLOAD ILIMITADOS',
    textCreditsPeriod1: 'por mês',
    textCreditsPeriod3: 'a cada três meses',
    textCreditsPeriod12: 'a cada ano',
    moreDetails: 'Mais Detalhes do Plano',
    breadcrumb0: 'Planos',
    breadcrumb1: 'Período',
    breadcrumb2: 'Dados Cadastrais',
    breadcrumb3: 'Detalhes do Pagamento',
    breadcrumb4: 'Confirmação',
    breadcrumbMobile2: 'Registro',
    breadcrumbMobile3: 'Pagamento',
    buttomPay: 'Ir para o pagamento',
    buttomLoginAndPay: 'Continuar',    
    buttomLoginBack: 'Voltar',       
    buttomSubscribe: 'Assinar Agora',
    buttomGoToLogin: 'Já tenho Cadastro',
    textWelcome: 'Bem-vindo ao Bella da Semana',
    // Variante exibida quando o plano escolhido em /assine foi o Gold.
    textWelcomeGold: 'Bem-vindo à Área Exclusiva do Bella da Semana',
    loginGoogle: 'Login com Google',
    loginFacebook: 'Fazer login com o Facebook',
    loginText: 'Ou escolha a opção:',
    loginText1: 'Ou fazer login com:',
    resumeTitle: 'Resumo do Pedido',
    titleForm: 'Dados para Cadastro',
    titleFormCheckout: 'Pagamento',
    footerOptionsCheckout: 'Todas as transações são seguras e encriptadas',
    checkPlanAndLogin: 'Para prosseguir, faça login e escolha um plano de assinatura ou créditos.',
    checkPlan: 'Para prosseguir, escolha um plano de assinatura ou créditos.',
    listaBeneficiosTipo: [
      'Mais de 400 modelos completamente nuas ',
      'Conteúdo Atualizado Diariamente ',
      'Um Novo Ensaio a Cada Semana ',
      "Seção Exclusiva 'Pezinhos' ",
      'Ensaios Completos com Fotos Inéditas ',
      'Mais de 60 mil Fotos das Bellas Nuas ',
      'Mais de 1000 Vídeos das Bellas Nuas ',
      'Assinatura Sigilosa: o nome Bella da Semana não Aparece na sua Fatura *',
      'Acesso a um Grupo Secreto no Telegram/WhatsApp ',
      'Bella Cloud: Sua Pasta na Nuvem para Fotos e Vídeos Favoritos'
    ],
    planBenefitsDesktop: [
      { text: 'Downloads de Vídeos, lives e making of ILIMITADOS', accessLevel: 'gold' },
      { text: 'Acesso as Lives gravadas', accessLevel: 'gold' },
      { text: 'GANHE até 60 Créditos de download', accessLevel: 'plus' },
      { text: 'Acesso aos ensaios AO VIVO', accessLevel: 'plus' },
      { text: '{horasGold} horas para assistir a Live', accessLevel: 'gold' },
      { text: '{horasPlus} horas para assistir a Live', accessLevel: 'plus' },
      { text: 'Acesso ao Making Of em 4K', accessLevel: 'plus' },
      { text: 'Vídeos em 4K', accessLevel: 'plus' },
      { text: 'Fotos em Alta Definição (HD)', accessLevel: 'plus' },
      { text: 'Mais de 400 modelos completamente nuas', accessLevel: 'all' },
      { text: 'Um Novo Ensaio a Cada Semana', accessLevel: 'all' },
      { text: 'Vídeos em 1080p Full HD', accessLevel: 'all' },
      { text: 'Mais de 60 mil Fotos e 1000 vídeos', accessLevel: 'all' },
      { text: 'Desconto na compra de Download', accessLevel: 'all' },
      { text: 'Seção Exclusiva "Pezinhos"', accessLevel: 'all' },
      { text: 'Bella Cloud: Sua Pasta na Nuvem para Fotos e Vídeos Favoritos', accessLevel: 'all' },
      { text: 'Assinatura Sigilosa: o nome Bella da Semana não aparece na sua Fatura', accessLevel: 'all' },
    ],
    // Lista NOVA usada apenas pelos componentes novos da tela única.
    // Cópia de planBenefitsDesktop SEM o item "GANHE até 60 Créditos". Os itens
    // exclusivos (gold/plus) ficam em negrito (mesmo padrão visual da original).
    planBenefitsDesktopV2: [
      { text: 'Downloads de Vídeos, Lives e Making of ILIMITADOS **', accessLevel: 'gold' },
      { text: 'Acesso as Lives gravadas', accessLevel: 'gold' },
      { text: 'Escolha as modelos do Especial<br>de Fim de Ano', accessLevel: 'gold' },
      { text: 'Vote no retorno de suas Bellas favoritas', accessLevel: 'gold' },
      { text: 'Indique musas para novos ensaios', accessLevel: 'gold' },
      { text: 'Acesso aos ensaios AO VIVO', accessLevel: 'plus' },
      { text: '{horasGold} horas para assistir a Live', accessLevel: 'gold' },
      { text: '{horasPlus} horas para assistir a Live', accessLevel: 'plus' },
      { text: 'Acesso ao Making Of em 4K', accessLevel: 'plus' },
      { text: 'Vídeos em 4K', accessLevel: 'plus' },
      { text: 'Fotos em Alta Definição (HD)', accessLevel: 'plus' },
      { text: 'Mais de 400 modelos nuas', accessLevel: 'all' },
      { text: 'Um Novo Ensaio a Cada Semana', accessLevel: 'all' },
      { text: 'Vídeos em 1080p Full HD', accessLevel: 'all' },
      { text: 'Mais de 60 mil Fotos e 1000 vídeos', accessLevel: 'all' },
      { text: 'Desconto na compra de Download', accessLevel: 'all' },
      { text: 'Seção Exclusiva "Pezinhos"', accessLevel: 'all' },
      { text: 'Bella Cloud: Sua Pasta na Nuvem para Fotos e Vídeos Favoritos', accessLevel: 'all' },
    ],
    planBenefitsMobile: {
      Basic: [
        'Mais de 400 modelos completamente nuas',
        'Um Novo Ensaio a Cada Semana',
        'Vídeos em 1080p Full HD',
        'Mais de 60 mil Fotos e 1000 vídeos',
        'Desconto na compra de Download',
        'Seção Exclusiva "Pezinhos"',
        'Bella Cloud: Sua Pasta na Nuvem para Fotos e Vídeos Favoritos',
      ],
      Plus: [
        '<b>GANHE</b> até <b>60 Créditos</b> de download',
        'Acesso aos ensaios <b>AO VIVO</b>',
        '<b>{horasPlus} horas</b> para assistir a Live',
        'Acesso ao Making Of em <b>4K</b>',
        'Vídeos em <b>4K</b>',
        'Fotos em Alta Definição <b>(HD)</b>',
      ],
      Gold: [
        'Downloads de Vídeos, lives e making of <b>ILIMITADOS **</b>',
        'Acesso as <b>Lives gravadas</b>',
        '<b>{horasGold} horas</b> para assistir a Live',
        'Escolha as modelos do <b>Especial<br>de Fim de Ano</b>',
        'Vote no retorno de suas <b>Bellas favoritas</b>',
        'Indique <b>musas</b> para novos ensaios',
      ],
    },
    planBenefitsInheritBasic: 'Tudo do Basic',
    planBenefitsInheritPlus: 'Tudo do Plus',
    conhecaObella: 'Conheça o Bella',
    bannerText1: 'Copie o código do cupom desconto e insira na hora do pagamento:',
    bannerText2: '*Disponíveis para os Planos Basic e Plus.',
    seoH1: 'Assine o Bella da Semana | Planos Basic, Plus e Gold',
    assineTitle1: 'Tenha acesso a fotos, vídeos',
    assineTitle2: ' e lives de + 400 modelos!',
    // Chamada do desktop quebrada em trechos (font-sizes distintos por trecho).
    assineIntroDesktop1: 'Tenha acesso a',
    assineIntroDesktop2: 'fotos, vídeos e lives',
    assineIntroDesktop3: 'de + 400 modelos!',
    assineIntroDesktop4: 'Faça parte do',
    assineIntroDesktop5: 'Clube Bella',
    // Coluna à esquerda quando o usuário está LOGADO mas SEM assinatura ativa
    // (substitui o texto de chamada do visitante nessa condição).
    assineInactiveTitle: 'Você já tem cadastro, mas sua assinatura não está ativa.',
    assineInactiveSub:
      'Não perca mais tempo! Recupere agora o acesso a mais de 1.000 vídeos e 60 mil fotos das modelos mais desejadas do país.',
    addCredits1: 'Bem-vindo ao clube',
    addCredits2: 'Comece a usar seus privilégios agora.',
    addCredits3: 'Como membro você garante o ',
    addCredits4: 'dobro de créditos de download ',
    addCredits5: 'pelo mesmo preço. Que tal já estrear essa vantagem e dar o primeiro passo na construção da sua coleção definitiva?',
    addCredits6: 'Avançar sem adicionar créditos',
    buttonAddCredits: 'SIM, QUERO CRÉDITOS EM DOBRO!',
    // Chaves da tela única de assinatura (grid desktop + carrossel mobile).
    buttonNext: 'PRÓXIMO',
    mostChosen: 'Mais Escolhido',
    secrecyFooter: '<b>Assinatura Sigilosa:</b> O nome Bella da Semana não Aparece na sua Fatura',
    useYourBalance: 'Use seu saldo',
    cellUnavailable: 'Indisponível',
  },
  ingles: {
    anual: '/ year',
    apartir: 'Starting at',
    conhecaObella: 'Get to know Bella',
    title: 'Subscribe Now!',
    bePart: 'Be part of Bella Club',    
    subTitle: 'And have a benefits club!',
    subTitleFreetour: 'It’s easy, fast, and safe.',
    legendFreetour: 'Choose the best plan for you and subscribe right now!',
    header: 'Not a member yet?',    
    codeEmail: 'We have sent a confirmation code to your email. Please enter the code below:',
    codeEmailSpam: 'Didn\'t receive the code? Check your spam or junk folder.',        
    subBenefits: 'Take advantage of the best Internet Club and have a world of benefits',
    listBenefits: [
      'HD photos',
      '4K* (Ultra HD) videos',
      'Watch live streams of uncensored rehearsals',
      'Access to all 4K *(ULTRA HD) recorded Making of',
      'Exclusive section only with delicate feet',
      'Full photoshoots with exclusive pictures',
      'Over 40,000 photos and hundreds of videos',
      'Bella Cloud: your cloud folder to keep your favorite photos and videos',
      "CONFIDENTIAL SUBSCRIPTION (Bella's name does not appear on his credit card statement or in his bank account)"
    ],
    legendFormPix: '',
    noticePixRecurrence: '',
    listBenefitsMobile: [
      'HD photos',
      '4K* (Ultra HD) videos',
      'Watch live streams of uncensored rehearsals',
      'Access to all 4K *(ULTRA HD) recorded Making of',
      'Exclusive section only with delicate feet',
      /*'Full photoshoots with exclusive pictures',*/
      'Over 40,000 photos and hundreds of videos',
      'Bella Cloud: your cloud folder for photos and videos'
      /*"CONFIDENTIAL SUBSCRIPTION (Bella's name does not appear on his credit card statement or in his bank account)."*/
    ],
    footerBenefits: '* All charges appear as BDS',
    footerDownloadLimit1: '** Limit of',
    footerDownloadLimit2: 'downloads per day',
    buttonSubscribe: 'Subscribe now',
    buttonSubscribe2: 'Subscribe',
    buttonSubscribe3: 'Be part',
    buttonSubscribe4: 'Go to upgrade',
    buttonSubscribe5: 'Renew',
    holderSocio: 'Are you already a member?',
    holderLogin: 'Log in',
    titleFormUser: 'Enter your details:',
    formUser: {
      firstName: 'Name',
      lastName: 'Last name',
      email: 'Email',
      emailAgain: 'Confirm your email',
      anotherEmail: 'Alternative email (optional)',
      country: 'Country',
      password: 'Password',
      passwordAgain: 'Retype your password',
      token: 'Email confirmation code',
    },
    captionSubscribePaymentsTitle:
      '*Valid for credit cards only. To obtain the installment payment, you must select how many installments you want (1x, 2x or 3x), just below the card security code request',
    captionSubscribePaymentsSubTitle:
      'For your convenience, your subscription will automatically renew for equivalent periods. To cancel, request via the Contact menu.',
    PlansSubTitle: 'Choose your payment method:',
    AlterPlansSubTitle: 'Choose your payment method:',
    AlterPaymentSubTitle: 'Payment method',
    nameHolderCreditCards: 'Holder name',
    cpfCreditCards: "holder's CPF",
    numberCreditCards: 'Card number',
    validCreditCards: 'Valid month/year',
    parcelas: 'Number of Installments',
    cvvCreditCards: 'Security code',
    cartaoInvalido: {
      number: 'Invalid card number. Please check the digits.',
      expiration: 'The card expiration date is invalid or has passed.',
      verification_value: 'Invalid security code.',
    },
    PlanValueDay: 'only',
    day: 'day',
    current: '$',
    legendFormCreditCard:
      'Your access is granted immediately after payment.<br>For greater discretion, the charge will appear on<br>your credit card statement as BDS.<br><br>The amount will be charged in Reais, using the current exchange rate. This may result in a small variation of a few cents on your invoice.',
    titleTermsUse: 'Terms and Conditions',
    aceitlabel: 'I have read and accept the terms and conditions.',
    buttonLabelFinish: 'Finish signature',
    captionMyAcoountPaymentsSubTitle1: `*Valid for credit card only. To obtain the installment plan, you must select how many installments you want (1x, 2x or 3x), just below the card security code request.`,
    captionMyAcoountPaymentsSubTitle2: `For your convenience, your subscription will automatically renew for equivalent periods. To cancel, request through the Contact menu.`,
    AlterPlansDescription1: 'Your current subscription plan is:',
    AlterPlansDescription2:
      'If you want to change the plan, simply select one of the options below.',
    AlterPaymentDescription1: 'Your current payment format is:',
    AlterPaymentDescription2:
      'If you would like to change your payment format, simply select one of the options below.',
    PromotionSpecial: 'PROMOTION',
    Promotionexclusive: 'EXCLUSIVE PROMOTION',
    labelDiscont: 'OFF',
    credits: {
      subBenefits:
        'Secure your download credits below and buy the videos exclusively for you to enjoy our models.',
      listBenefits: [
        'Bella Club subscribers <b>get DOUBLE the credits;</b>',
        /*'There is no need for an active subscription, providing complete freedom of choice;',*/
        'Enjoy exclusive content and watch your favorite models in 4K;',
        'Save videos to watch anywhere, without the need for an internet connection.',
        /*'Practicality: watch anywhere, without the slightest need for an internet connection.'*/
      ],
      title: 'Purchase credits for download!',
      subTitle: 'And get exclusive 4K videos and making of your favorite models!',
      title2: 'Boost Your Subscription!',
      subTitle2:
        'Add more video and making of download credits to your account with a special discount.',
        buy: 'Buy',
gain: 'and get',
credits: 'credits',
      footerBenefits: '* Each download of 1 video corresponds to 1 credit',
      footerBenefits2: '* Each download of 1 making of corresponds to 2 credits',
      PlansSubTitle: 'know our download packages:',
      PlansAssi: 'Subscriber',
      PlansNoAssi: 'Non-Subscriber',
      PlansTitle: 'Choose the amount of credits:',
      recive: 'receives',
      price: 'Value',
      option: 'Select the desired option:',
      subscribeInfo:
        'To complete your purchase as a subscriber, you must have an active BellaClub subscriber account. You will be redirected to the login page before payment.'
    },
    buttonCredits: 'Buy Credits',
    buttonCredits2: 'Buy Now',
    buttonCreditsAssinante: 'YES, I WANT DOUBLE CREDITS!',
    PlanPrevTitle: 'Know our plans:',
    double: 'GET DOUBLE',
    assineOptions1: 'Subscription Plan',
    assineOptions2: 'Credits for Downloads',
    perMonth: '/ month',
    totalValue: 'Total',
    textCredits1: '+ BONUS',
    textCredits2: 'Earn up to',
    textCredits3: 'download credits',
    textCredits4: 'unlimited',
    // Gold credits message in 2 lines (GANHE/+ BONUS highlighted).
    textCreditsWord: 'credits',
    textCreditsUnlimited: 'UNLIMITED DOWNLOADS',
    textCreditsPeriod1: 'per month',
    textCreditsPeriod3: 'every three months',
    textCreditsPeriod12: 'every year',
    moreDetails: 'More Plan Details',
    breadcrumb0: 'Plans',
    breadcrumb1: 'Period',
    breadcrumb2: 'Registration Data',
    breadcrumb3: 'Payment Details',
    breadcrumb4: 'Confirmation',
    breadcrumbMobile2: 'Register',
    breadcrumbMobile3: 'Payment',
    buttomPay: 'Go to payment',
    buttomLoginAndPay: 'Continue',
    buttomLoginBack: 'Back',
    buttomSubscribe: 'Subscribe Now',
    buttomGoToLogin: 'I already have an account',
    textWelcome: 'Welcome to Bella Club',
    // Variante exibida quando o plano escolhido em /assine foi o Gold.
    textWelcomeGold: 'Welcome to the Bella Club Exclusive Area',
    loginGoogle: 'Log in with Google',
    loginFacebook: 'Log in with Facebook',
    loginText: 'Or choose the option:',
    loginText1: 'Or log in with:',
    resumeTitle: 'Order Summary',
    titleForm: 'Registration Data',
    titleFormCheckout: 'Payment',
    footerOptionsCheckout: 'All transactions are secure and encrypted.',
    checkPlanAndLogin: 'To proceed, log in and choose a subscription plan or credits.',
    checkPlan: 'To proceed, choose a subscription plan or credits.',
    legendFormBoleto: '',
    listaBeneficiosTipo: [
      'Over 400 completely nude models',
      'Content Updated Daily',
      'A New Shoot Every Week',
      'Exclusive "Feet" Section',
      'Complete Shoots with Unpublished Photos',
      'Over 60 thousand Photos of Nude Bellas',
      'Over 1000 Videos of Nude Bellas ',
      'Confidential Subscription: the Bella Club name does not appear on your invoice *',
      'Access to a Secret Group on Telegram/WhatsApp',
      'Bella Cloud: Your Cloud Folder for Favorite Photos and Videos'
    ],
    planBenefitsDesktop: [
      { text: 'UNLIMITED Video, Lives, and Making Of Downloads', accessLevel: 'gold' },
      { text: 'Access to recorded Lives', accessLevel: 'gold' },
      { text: 'GET up to 40 download Credits', accessLevel: 'plus' },
      { text: 'Access to LIVE photoshoots', accessLevel: 'plus' },
      { text: '{horasGold} hours to watch the Live', accessLevel: 'gold' },
      { text: '{horasPlus} hours to watch the Live', accessLevel: 'plus' },
      { text: 'Access to Making Of in 4K', accessLevel: 'plus' },
      { text: '4K Videos', accessLevel: 'plus' },
      { text: 'High Definition (HD) Photos', accessLevel: 'plus' },
      { text: 'More than 400 completely nude models', accessLevel: 'all' },
      { text: 'A New Photoshoot Every Week', accessLevel: 'all' },
      { text: 'Videos in 1080p Full HD', accessLevel: 'all' },
      { text: 'More than 60,000 Photos and 1,000 videos', accessLevel: 'all' },
      { text: 'Discount on Download Purchases', accessLevel: 'all' },
      { text: 'Exclusive "Pezinhos" Section', accessLevel: 'all' },
      { text: 'Bella Cloud: Your Cloud Folder for Favorite Photos and Videos', accessLevel: 'all' },
      { text: 'Confidential Subscription: the Bella da Semana name does not appear on your invoice', accessLevel: 'all' },
    ],
    // NEW list used only by the new single-screen components.
    // Copy of planBenefitsDesktop WITHOUT the "GET up to 60 Credits" item.
    // Exclusive items (gold/plus) are bold (same visual pattern as the original).
    planBenefitsDesktopV2: [
      { text: 'UNLIMITED Video, Lives, and Making Of Downloads', accessLevel: 'gold' },
      { text: 'Access to recorded Lives', accessLevel: 'gold' },
      { text: 'Choose Year-End Special models', accessLevel: 'gold' },
      { text: 'Vote for favorite Bellas to return', accessLevel: 'gold' },
      { text: 'Nominate muses for new shoots', accessLevel: 'gold' },
      { text: 'Access to LIVE photoshoots', accessLevel: 'plus' },
      { text: '{horasGold} hours to watch the Live', accessLevel: 'gold' },
      { text: '{horasPlus} hours to watch the Live', accessLevel: 'plus' },
      { text: 'Access to Making Of in 4K', accessLevel: 'plus' },
      { text: '4K Videos', accessLevel: 'plus' },
      { text: 'High Definition (HD) Photos', accessLevel: 'plus' },
      { text: 'More than 400 nude models', accessLevel: 'all' },
      { text: 'A New Photoshoot Every Week', accessLevel: 'all' },
      { text: 'Videos in 1080p Full HD', accessLevel: 'all' },
      { text: 'More than 60,000 Photos and 1,000 videos', accessLevel: 'all' },
      { text: 'Discount on Download Purchases', accessLevel: 'all' },
      { text: 'Exclusive "Pezinhos" Section', accessLevel: 'all' },
      { text: 'Bella Cloud: Your Cloud Folder for Favorite Photos and Videos', accessLevel: 'all' },
    ],
    planBenefitsMobile: {
      Basic: [
        'More than 400 completely nude models',
        'A New Photoshoot Every Week',
        'Videos in 1080p Full HD',
        'More than 60,000 Photos and 1,000 videos',
        'Discount on Download Purchases',
        'Exclusive "Pezinhos" Section',
        'Bella Cloud: Your Cloud Folder for Favorite Photos and Videos',
      ],
      Plus: [
        '<b>GET</b> up to <b>60 Credits</b> for download',
        'Access to <b>LIVE</b> photoshoots',
        '<b>{horasPlus} hours</b> to watch the Live',
        'Access to Making Of in <b>4K</b>',
        '<b>4K</b> Videos',
        'High Definition <b>(HD)</b> Photos',
      ],
      Gold: [
        '<b>UNLIMITED</b> Video, Lives, and Making Of Downloads **',
        'Access to <b>recorded Lives</b>',
        '<b>{horasGold} hours</b> to watch the Live',
        'Choose <b>Year-End Special</b> models',
        'Vote for <b>favorite Bellas</b> to return',
        'Nominate <b>muses</b> for new shoots',
      ],
    },
    planBenefitsInheritBasic: 'Everything in Basic',
    planBenefitsInheritPlus: 'Everything in Plus',
    bannerText1: 'Copy the discount coupon code and enter it at checkout:',
    bannerText2: '*Available for Basic and Plus Plans.',
    seoH1: 'Subscribe to Bella Club | Basic, Plus and Gold plans',
    assineTitle1: 'Get access to photos, videos',
    assineTitle2: ' and live streams of 400+ models!',
    // Desktop call-to-action split into segments (distinct font-sizes per segment).
    assineIntroDesktop1: 'Get access to',
    assineIntroDesktop2: 'photos, videos and lives',
    assineIntroDesktop3: 'of 400+ models!',
    assineIntroDesktop4: 'Be part of',
    assineIntroDesktop5: 'Bella Club',
    // Left column when the user is LOGGED IN but has NO active subscription
    // (replaces the visitor call-to-action in this state).
    assineInactiveTitle: 'You already have an account, but your subscription is not active.',
    assineInactiveSub:
      "Don't waste any more time! Get back access now to over 1,000 videos and 60,000 photos of the most desired models in the country.",
    addCredits1: 'Welcome to the club.',
    addCredits2: 'Start enjoying your privileges now.',
    addCredits3: 'As a member, you get ',
    addCredits4: 'double the download credits ',
    addCredits5: 'for the same price. How about trying out this benefit now and taking the first step toward building your ultimate collection?',
    addCredits6: 'Proceed without adding credits',
    buttonAddCredits: 'YES, I WANT DOUBLE CREDITS!',
    // Single-screen subscription keys (desktop grid + mobile carousel).
    buttonNext: 'NEXT',
    mostChosen: 'Most Chosen',
    secrecyFooter: '<b>Confidential Subscription:</b> The name Bella da Semana does not appear on your invoice',
    useYourBalance: 'Use your balance',
    cellUnavailable: 'Unavailable',
  }
}

export default translateAssine
